__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "platform-uidispatcher";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("oidc-client-ts", "3.5.0", () => (__webpack_require__.e(472).then(() => (() => (__webpack_require__(70472))))));
			register("react-dom/client", "19.3.1", () => (Promise.all([__webpack_require__.e(7470), __webpack_require__.e(2466), __webpack_require__.e(6460)]).then(() => (() => (__webpack_require__(7470))))));
			register("react-dom", "19.3.1", () => (Promise.all([__webpack_require__.e(2466), __webpack_require__.e(8325)]).then(() => (() => (__webpack_require__(78325))))));
			register("react", "19.3.1", () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__(63696))))));
			register("reflux", "0.4.1", () => (__webpack_require__.e(1198).then(() => (() => (__webpack_require__(41198))))));
			initExternal(6929);
			initExternal(56190);
			initExternal(22722);
			initExternal(4019);
			initExternal(51438);
			initExternal(98571);
			initExternal(37705);
			initExternal(73610);
			initExternal(22186);
			initExternal(78460);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};